<template>

    <div class="mb-3">

        <label class="form-label" :for="id">{{ translatedLabel }}</label>
        <editor api-key="no-api-key" 
                v-bind="$attrs" 
                ref="input"
                :id="id"
                :rows="15"
                :init="editorOptions"
                :initial-value="value"
                :class="[ error ? 'is-invalid' : '', className ]" 
                @input="input"
                />
        <div v-if="error" class="invalid-feedback">{{ error }}</div>

    </div>

</template>

<style>

</style>

<script>
    // @todo lädt script von tinymce.com
    import Editor from '@tinymce/tinymce-vue';
    
    export default {
        inheritAttrs: false,
        props: {
            id: {
                type: String,
                default() {
                    return `editor-input-${this._uid}`
                },
            },
            value: String,
            label: String,
            className: {
                default: '',
            },
            error: String,
            help: String,
        },
        data() {
            return {
                editorOptions: {
                    height: 500,
                    branding: false,
                    language: 'de',
                    plugins: [
                        'advlist autolink lists link image charmap print preview anchor',
                        'searchreplace visualblocks code fullscreen',
                        'insertdatetime media table paste code help wordcount'
                    ],
                    toolbar: 'undo redo styleselect bold italic alignleft aligncenter alignright alignjustify | link image media | bullist numlist outdent indent | code'
                },
            }
        },
        components: {
            Editor,
        },
        computed: {
            translatedLabel() {
                return this.langHas('validation.attributes.' + this.label)
                        ? this.__('validation.attributes.' + this.label)
                        : this.label;
            }
        },
        methods: {
            input(value) {
                this.$emit('input', value);
            },
            focus() {
                this.$refs.input.focus()
            },
            select() {
                this.$refs.input.select()
            },
        },
    }
</script>
